export default __webpack_public_path__ + "static/media/BONEswap.353d7f64.png";